import React, { Suspense, useEffect } from 'react'

import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { CompatRouter } from 'react-router-dom-v5-compat'
import { HelmetProvider } from 'react-helmet-async'
import { PersistGate } from 'redux-persist/integration/react'

import { ThemeProvider as ThemeProviderV5, styled } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { PatchedAdapterDateFns } from 'providers/PatchedAdapterDateFns'

import Paper from '@mui/material/Paper'

import { store, sagaMiddleware, persistor } from 'providers/store'
import { register } from 'swiper/element/bundle'

import rootSaga from 'middleware/sagas'
import history from 'providers/history'

import MainContainer from 'components/common/MainContainer'
import haulerHeroThemeV5 from 'theme/themeV5'
import MainRoute from 'router'

import 'mapbox-gl/dist/mapbox-gl.css'
import 'styles/common.scss'
import './App.css'
import 'overrides.scss'
import WithFirebase from 'providers/WithFirebase'
import AuthProvider from 'auth/AuthContext'
import { ImpersonationProvider } from 'providers/ImpersonationProvider'
import Loader from 'components/common/loader'
import NavbarWrapper from 'components/common/NavbarWrapper'
import AppWrapper from './AppWrapper'

sagaMiddleware.run(rootSaga)

const MainContent = styled(Paper)`
  flex: 1;
  height: 100%;
  display: flex;
  flex-flow: column;
  background-color: #f7f9fc;
  border-radius: 0px;
  box-shadow: none;
`

const App = () => {
  useEffect(() => {
    register()
  }, [])

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <AuthProvider>
          <ImpersonationProvider>
            <WithFirebase>
              <AppWrapper>
                <HelmetProvider>
                  <ThemeProviderV5 theme={haulerHeroThemeV5}>
                    <LocalizationProvider dateAdapter={PatchedAdapterDateFns}>
                      <MainContent className="MainContentWrapper">
                        <Router history={history}>
                          <CompatRouter>
                            <MainContainer>
                              <Suspense
                                fallback={
                                  // Contained so the navbar stays put and body scroll is left
                                  // alone: the full-screen form flashed over the whole app on
                                  // every first route load and flipped the scrollbar.
                                  <NavbarWrapper innerSx={{ position: 'relative' }}>
                                    <Loader contained />
                                  </NavbarWrapper>
                                }
                              >
                                <MainRoute />
                              </Suspense>
                            </MainContainer>
                          </CompatRouter>
                        </Router>
                      </MainContent>
                    </LocalizationProvider>
                  </ThemeProviderV5>
                </HelmetProvider>
              </AppWrapper>
            </WithFirebase>
          </ImpersonationProvider>
        </AuthProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
